<template>
  <div>
    <transition name="fade">
      <LoadingMask v-if="onload" />
    </transition>
    <div class="c-app" v-if="!onload && $route.query.brandID">
      <TheSidebar />
      <div class="c-wrapper">
        <TheHeader />
        <div :class="[{ 'c-body': isUseClass }]">
          <main :class="[{ 'c-main': isUseClass }]">
            <CContainer fluid :class="[{ 'p-0': !isUseClass }]">
              <transition name="fade">
                <router-view :key="$route.fullPath"></router-view>
              </transition>
            </CContainer>
          </main>
        </div>
        <TheFooter />
      </div>
    </div>
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "./TheFooter";
import { mapGetters } from "vuex";
import LoadingMask from "@/views/pages/LoadData";
import $ from "jquery";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    LoadingMask,
  },
  computed: {
    ...mapGetters(["isLoading", "getBrandDetail"]),
  },
  data() {
    return {
      onload: true,
      isUseClass: true,
    };
  },
  watch: {
    "$route.fullPath": function() {
      this.checkRouter();
    },
  },
  methods: {
    checkRouter() {
      var routePrevent = ["FLOW BUILDER"];
      if (routePrevent.includes(this.$route.name)) {
        this.isUseClass = false;
      } else {
        this.isUseClass = true;
      }
    },
    getDataProfile: function() {
      var admin_token = this.$cookies.get("admin-token");
      if (admin_token) {
        this.axios.get(`${this.$baseUrl}/user`).then((res) => {
          res.detail.token = admin_token;
          this.$store.dispatch("setUserData", res.detail);
          if (this.$route.query.brandID != res.detail.brandId) {
            this.$router.replace({ query: { brandID: res.detail.brandId } });
          }
        });
        this.getBrandList();
      }
      this.setTimeStapm();
    },
    getBrandList: function() {
      var admin_brand_id = this.$route.query.brandID;
      this.axios.get(`${this.$baseUrl}/brand/list`).then((res) => {
        if (res.result) {
          this.$store.dispatch("setBrandList", res.detail);
          if (!admin_brand_id) {
            this.$store.dispatch(
              "setCurrentBrandID",
              this.$store.getters.getBrandList()[0].id
            );
            this.$router.replace({
              name: "CHAT ANALYSIS",
              query: { brandID: this.$store.getters.getBrandList()[0].id },
            });
          } else {
            let brandPermission = this.$store.getters
              .getBrandList()
              .find((el) => el.id == admin_brand_id);
            if (brandPermission) {
              this.$store.dispatch("setCurrentBrandID", admin_brand_id);
            } else {
              this.$store.dispatch(
                "setCurrentBrandID",
                this.$store.getters.getBrandList()[0].id
              );
              this.$router.replace({
                name: "CHAT ANALYSIS",
                query: { brandID: this.$store.getters.getBrandList()[0].id },
              });
            }
          }
        }
      });
    },
    setTimeStapm() {
      this.$store.watch(
        (state) => {
          return this.isLoading();
        },
        (val) => {
          if (!this.isLoading()) {
            setTimeout(() => {
              this.onload = false;
            }, 1000);
          }
        },
        {
          deep: true,
        }
      );
    },
  },
  created: function() {
    this.getDataProfile();
    this.checkRouter();
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
